import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../service';
import { search, SearchFeild } from '../../Common';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { EmployeeBiometricSchemaObject } from '../EmployeeSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import divisionService from '../../Devision/services'
import Joi from '@hapi/joi'
import { TextField } from '@material-ui/core';
import FileBase64 from 'react-file-base64';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { Button } from '@material-ui/core';
import { CommonEncryptParam } from '../../../../utils/CommonParams';

const screenCode = 'RSMEMPLOYEE'

export function Listing(props) {
    const [employees, setEmployees] = useState([]);
    const [employeeSearchData, setEmployeeSearchData] = useState({
        groupID: 0,
        operationEntityID: 0,
        registrationNumber: '',
        NIC: ''

    });
    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["employeeCode", "fullName"]
    const [files, setFiles] = useState({});
    const [productImage, setProductImage] = useState({});
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(EmployeeBiometricSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [employeeSearchData.groupID]);

    useEffect(() => {
        trackPromise(
            handleSearch()
        )
    }, [employeeSearchData.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    async function getPermissions() {

        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWRSMEMPLOYEE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDRSMEMPLOYEE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setEmployeeSearchData({
            ...employeeSearchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function getOperationEntities() {
        var data = await divisionService.getEstatesByGroupID(employeeSearchData.groupID);
        setOperationEntities(data);

    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result);
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function handleEmployeeBioClick(employee) {
        props.history.push({
            pathname: 'employee/employeeBiometricAddEdit',
            data: employee,
            edit: true,
            screen: 'rsm'
        })
    }

    function handleEmployeeCardClick(employee) {
        props.history.push({
            pathname: 'rsmemployee/addEdit/' + CommonEncryptParam(employee.employeeID.toString()),
            data: employee,
            edit: true
        })
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function handleSearch(e) {
       
        if (e !== undefined)
            e.preventDefault();

        if (e !== undefined) {
            const errorMessages = validate(schema, employeeSearchData);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.GetEmployeeDetails(employeeSearchData);

        setIsTableHide(false);
        destroyDataTable();
        setEmployees(response);
        createDataTable();
    }

    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, EmployeeBiometricSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setEmployeeSearchData({
            ...employeeSearchData,
            [e.target.name]: value
        })

        setErrors(error)
    }

    function clearState() {
        setEmployeeSearchData({
            ...employeeSearchData,
            groupID: '0',
            operationEntityID: '0',
            collectionPointID: '0',
            aspNetUserID: '0',
        });
        destroyDataTable();
        setEmployees([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        clearState();
    }
    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (
            <td key={index}>{da[row] + " "}</td>
           )
        )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Rsm Employee"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add RSM Employee"
                                    path="rsmemployee/addEdit" />
                            </div>
                            <hr />
                            <form onSubmit={(e) => handleSearch(e)}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group ID *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={employeeSearchData.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={employeeSearchData.operationEntityID}
                                            onChange={(e) => handleChange(e)}>

                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md">
                                        <TextField fullWidth label="Registration No"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={employeeSearchData.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                    </div>
                                    <div className="col-md">
                                        <TextField fullWidth label="NIC"
                                            name="NIC"
                                            id="NIC"
                                            value={employeeSearchData.NIC}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, employeeSearchData)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            <div className="table-responsive row-top-gap" >
                                <table id="example" className="display dataTable no-footer" hidden={isTableHide}>
                                    <thead>
                                        <tr>
                                            <th>Employee Code</th>
                                            <th>Employee Name</th>
                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                {employees.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {content(data)}
                                            <td>
                                                <div class="btn-group">
                                                    <Button onClick={() => handleEmployeeCardClick(data)} style={{ cursor: "pointer" }}><i class="far fa-edit"></i></Button>
                                                    <Button onClick={() => handleEmployeeBioClick(data)} style={{ cursor: "pointer" }}> <i class="fas fa-tasks"></i></Button>
                                                </div>

                                            </td> 
                                        </tr>
                                    );
                                })}
                            </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )


}